window.epi_recharge_bridge = {
  bundlecache: {},
  bundleitemcache: null,
  cacheBundleItems: async function (vids) {
    const query = /* GraphQL */ `
      query getBundleVariants($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            title
            product {
              title
              handle
            }
          }
        }
      }
`;
    const url = `https://${Shopify.shop}/api/2025-10/graphql.json`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": window.STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: {
          ids: vids.map((_) =>
            _.indexOf("gid:") === 0 ? _ : `gid://shopify/ProductVariant/${_}`,
          ),
        },
      }),
    });
    const { data } = await response.json();
    this.bundleitemcache = data.nodes.filter((_) => !!_); //some null nodes if not storefront api published, handle in case (data has been fixed)
    return data.nodes;
  },
  getBundleInfo: async function (productId, variantId) {
    const prodInfo =
      this.bundlecache[productId] ??
      (await recharge.cdn.getCDNBundleSettings(productId));
    if (!prodInfo) return []; //non bundles return null from that method.
    this.bundlecache[productId] = prodInfo;

    if (!this.bundleitemcache) {
      const variants = prodInfo.variants;
      const uniqueExternalIds = [
        ...new Set(
          variants.flatMap((v) =>
            v.selection_defaults.map((item) => item.external_variant_id),
          ),
        ),
      ];
      await this.cacheBundleItems(uniqueExternalIds);
    }
    //now using the prodInfo, variantId, and the item cache, pick out the items:
    const items = prodInfo.variants.find(
      (_) => _.external_variant_id == variantId,
    ).selection_defaults;

    const bundleData = items.map((_) => ({
      quantity: _.quantity,
      variant_id: _.external_variant_id,
      item: {
        title: this.bundleitemcache.find((x) =>
          x.id.includes(_.external_variant_id),
        )?.product?.title,
        subtitle: this.bundleitemcache.find((x) =>
          x.id.includes(_.external_variant_id),
        )?.title
      },
    }));

    return bundleData;
  },
};

const scriptEl = document.currentScript;
const permanentDomain = scriptEl?.dataset?.permanentDomain;

recharge.init({
  storeIdentifier: permanentDomain,
  storefrontAccessToken:
    "strfnt_b7d684962f4924ebcf22d1da19c9bc84bf13c3bf52d165aab59f27e67eb8d004",
  loginRetryFn: () => {
    return recharge.auth.loginShopifyAppProxy().then((session) => {
      console.log("loginRetryFn", session); //.apiToken
      return session;
    });
  },
});

document.addEventListener("DOMContentLoaded", async () => {
  if (
    !document.querySelector(
      "div.grid-item div[data-productid] p.product-subscription-price",
    )
  )
    return;
  if (!document.getElementById("ProductGridContainer")) return;

  let nextActiveSubcription = null;
  let portalAccess = null;
  const isBeta = location.hostname === "shop.epicured.com";

  const session = location.pathname.includes("tools/recurring/portal")
    ? await recharge.auth.loginCustomerPortal()
    : await recharge.auth.loginShopifyAppProxy(); //session: { apiToken:string, customerId:number }
  if (!session || !session.customerId) {
    isBeta && console.log("no recharge session or customer Id");
    return;
  }
  isBeta && console.log(session);

  const { subscriptions } = await recharge.subscription.listSubscriptions(
    session,
    {
      //limit, sort_by, what else is supported?
      status: "active",
      include: "address",
    },
  );

  let sortedActiveSubs = subscriptions
    .filter((_) => _.status === "active" && _.next_charge_scheduled_at)
    .sort((a, b) =>
      a.next_charge_scheduled_at.localeCompare(b.next_charge_scheduled_at),
    );

  if (!sortedActiveSubs.length) {
    isBeta && console.log("no active subs");
    return;
  }
  // if(sortedActiveSubs.length) {
  //     nextActiveSubcription = sortedActiveSubs[0];
  //     for(let s of sortedActiveSubs){
  //          window.epi_recharge_bridge.subscription_to_zip_map[String(s.id)] = s.include.address.zip;
  //     }
  // }
  // else
  // {
  //    isBeta && console.log('no active subs');
  //    return;
  // }

  isBeta && console.log("nextActiveSubcription", nextActiveSubcription);
  portalAccess = await recharge.customer.getCustomerPortalAccess(session);
  isBeta && console.log("portalAccess", portalAccess);
  injectAddButtons();

  //handle filter use etc that doesn't reload page but changes products:
  const targetElement = document.getElementById("ProductGridContainer");
  if (targetElement) {
    isBeta &&
      console.log("installing mutation observer for #ProductGridContainer");
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.target.id === "ProductGridContainer") {
          injectAddButtons();
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetElement, { childList: true, subtree: true });
  }

  function injectAddButtons() {
    Array.from(
      document.querySelectorAll(
        "div.grid-item div[data-productid] p.product-subscription-price",
      ),
    ).forEach((_) => {
      const { productid } = _.closest("div[data-productid]").dataset;
      if (productid) {
        let url = `${portalAccess.base_url}${portalAccess.customer_hash}/overview?token=${portalAccess.temp_token}&product=${productid}`;
        let html = `<a href="${url}" class="shadow" style="font-size:12px;line-height:12px;padding:0.5em;border-radius:4px;display:flex;gap:.25rem;align-items:center;color: #860f0f;border-color: #860f0f;border-width: 1px;font-weight: bold;">
            <svg width="24px" height="24px" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_iconCarrier"> <path id="Vector" d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M14 13V10M14 10V7M14 10H11M14 10H17M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="currentColor" fill="transparent" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
            ADD TO MY NEXT DELIVERY</a>`;
        _.insertAdjacentHTML("afterend", html);
      }
    });
  }
});
